$("#carousel .item").each(function () {
  const $item = $(this);
  const $bannerTexts = $item.find(".extended-banner-texts");
  const imageAlt = $item.find("img").first().attr("alt");

  if (imageAlt && !$bannerTexts.children(".tl").length) {
    $("<div>", { class: "tl", text: imageAlt }).prependTo($bannerTexts);
  }
  //$item.append('<div class="heureka"><div class="h3">99%</div> <span class="ts">zákazníků doporučuje</span> </div>');
 // $item.append('<div class="stars"><span class="star star-on"></span><span class="star star-on"></span><span class="star star-on"></span><span class="star star-on"></span><span class="star star-on"></span></div>');


 // $item.find(".extended-banner-texts").append('<div class="heureka"><div class="h3">99%</div> <span class="ts">zákazníků doporučuje</span> </div>');
 // $item.find(".extended-banner-texts .heureka .h3").append('<div class="stars"><span class="star star-on"></span><span class="star star-on"></span><span class="star star-on"></span><span class="star star-on"></span><span class="star star-on"></span></div>');
});

if ($(".in-index").length) {
  $(".carousel").each(function () {
    const $carousel = $(this);
    if ($carousel.find(".carousel-indicators").length) return;

    const carouselId = $carousel.attr("id");
    const $indicators = $('<ol class="carousel-indicators"></ol>').appendTo($carousel);

    $carousel
      .find(".carousel-inner")
      .children(".item")
      .each(function (index) {
        $("<li>", {
          "data-target": "#" + carouselId,
          "data-slide-to": index,
          class: index === 0 ? "active" : "",
        }).appendTo($indicators);
      });
  });
}
